export const CustomerAnalyticsStyles = {
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        paddingY: "2rem",
      },
    header: {
        display:'flex',
        justifyContent:'space-between',
        paddingLeft: '0.5rem',
    },
    summaryCard: {
        minWidth: 400,
        maxWidth: 450,
        height:'fit-content',
        borderRadius:"0.5rem"
    },
    filtersCard : {
        width: "100%",
        height:'fit-content',
        borderRadius:"0.5rem"
    },
    filtersCardContent: {
        width:'100%',
        display:'flex',
        flexDirection:'column',
        justifyContent:'start'
    },
    filtersCardTopContent: {
        width:'100%',
        display:'flex',
        justifyContent:'flex-end',
    },
    dateRangePicker: {
        marginBottom: '1.5rem',
        minWidth: 260,
    },
    sessionListContainer: {
        minWidth: 400,
        maxWidth: 450,
        border:'1px solid rgba(0, 0, 0, 0.12)',
        borderRadius:'0.5rem',
        display: 'flex',
        flexDirection:'column',
        padding:'0.5px'
    },
    sessionList: {
        maxHeight: 450,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: "2px",
        padding:'0.5rem'
    },
    sessionCard: {
        marginBottom: '1rem',
        padding: '1rem',
        borderRadius: '10px',
        boxShadow: 1,
    },
    statusDropdown: {
        display:'flex',
        width:'300px',
        marginTop: '0.4rem',
    },
    summaryDateFilterContainer:{
        display:'flex',
        justifyContent:'space-between',
        gap:2
    },
    dateFieldsContianer: {
        display: "flex",
        alignSelf: "flex-end",
        gap: 2,
      },
      sessionsHeadingContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        backgroundColor: "#f5f5f5 ",
        zIndex: 999,
        borderRadius:'0.5rem',
      },
    bottomContainer:{
        display:'flex',
        justifyContent:'space-between',
        gap:2,
        width: "100%",
        paddingY:1
    },
    pieChartContainer: {
        width: "100%",
        height: "70vh",
        overflowY: "scroll",
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
        boxShadow:
          "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        minHeight: "500px",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": { display: "none" },
    }, 
    PieChartHeadingContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingRight: "1rem",
        position: "sticky",
        top: 0,
        backgroundColor: "#f5f5f5 ",
        zIndex: 999,
    },   
} 